import posthog from "posthog-js";
import { blockReplayForPage } from "@/lib/analytics/replay-gate";
import type { AnalyticsProvider } from "../types";

export const posthogProvider: AnalyticsProvider = {
  name: "posthog",
  track: (event, properties) => posthog.capture(event, properties),
  group: (groupType, groupKey, traits) => {
    posthog.group(groupType, groupKey, traits);
  },
  resetGroups: () => {
    posthog.resetGroups();
  },
  identify: (userId, traits) => {
    posthog.identify(userId, traits);
  },
  reset: () => {
    try {
      posthog.reset();
    } catch (error) {
      blockReplayForPage();
      posthog.stopSessionRecording();
      if (error instanceof DOMException && error.name === "SecurityError") {
        return;
      }
      throw error;
    }
  },
};
